import { render } from "./AppSkeleton.vue?vue&type=template&id=c34d8cc4&scoped=true&ts=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=ts"
export * from "./AppSkeleton.vue?vue&type=script&lang=ts"

import "./AppSkeleton.vue?vue&type=style&index=0&id=c34d8cc4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34d8cc4"]])

export default __exports__